import React, {useCallback, useEffect, useState} from 'react';
import {OfficeList} from "../../../../components/admin/office/OfficeList";
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {officeResultCollectionType, officeResultType} from "../../../../types/Api/OfficeResultType";
import {officeHydrator} from "../../../../models/hydrator/officeHydrator";
import {office} from "../../../../models/office";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {defaultPagination} from "../../../../types/PaginationType";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {Pagination} from "../../../../components/admin/Pagination";
import {Tab} from "../../../../components/admin/office/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [offices, setOffices] = useState([] as office[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findOffice = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'enabled',
      direction: 'DESC'
    });

    apiFilters.addSort({
      by: 'label',
      direction: 'DESC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<officeResultCollectionType> = ApiService.get('/office', apiFilters) as Promise<officeResultCollectionType>;

    result
      .then((r: officeResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setOffices(r._embedded.offices.map((office: officeResultType) => {
          return officeHydrator.hydrate(office);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setOffices([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, page]);

  useEffect(() => {
    findOffice();
  }, [findOffice]);

  return (
    <>
      <BoxTitle title="Gestion du bureau"/>
      <Tab />
      <OfficeList offices={offices} loading={loading} refresh={findOffice}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/office/office/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un bureau
        </NavLink>
      </div>
    </>
  )
}
